import { render, staticRenderFns } from "./Bigtitle.vue?vue&type=template&id=6a2f4723"
import script from "./Bigtitle.vue?vue&type=script&lang=js"
export * from "./Bigtitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports